import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_ACTION_CHANGED, ANALYTICS_ACTION_CLICKED, ANALYTICS_SUBJECT_BUTTON, ANALYTICS_SUBJECT_LINK, ANALYTICS_SUBJECT_SEARCH } from '@atlassian/mpac-analytics';
import { APP_LINK, CREATE_APP, MANAGE_PARTNER_APPS_VIEW, SEARCH_APP } from '../../../../analytics/Events';
export const appSearchAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_APPS_VIEW,
  action: ANALYTICS_ACTION_CHANGED,
  actionSubject: ANALYTICS_SUBJECT_SEARCH,
  actionSubjectId: SEARCH_APP,
  attributes: _objectSpread({}, attributes)
});
export const createAppButtonAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_APPS_VIEW,
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_BUTTON,
  actionSubjectId: CREATE_APP,
  attributes: _objectSpread({}, attributes)
});
export const appVersionLinkAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_APPS_VIEW,
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_LINK,
  actionSubjectId: APP_LINK,
  attributes: _objectSpread({}, attributes)
});